module.exports = __webpack_public_path__ + "static/img/img_cabinet.41831164.png";